module.exports = __webpack_public_path__ + "static/media/  (177).a706b578.jpg";